import { render } from "./TradesOverviewIncoming.vue?vue&type=template&id=f584e1ce"
import script from "./TradesOverviewIncoming.vue?vue&type=script&lang=js"
export * from "./TradesOverviewIncoming.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__